import React from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import { layout } from '@almacareer/profesiaui/styles/layout';

interface CenteredLayoutProps {
    maxWidth?: string;
}

const CenteredContent = ({
    maxWidth = layout.centeredLayoutContentWidth,
    children,
    ...props
}: React.PropsWithChildren<CenteredLayoutProps & BoxProps>) => {
    return (
        <Box
            data-testid="centered-content"
            {...props}
            marginLeft="auto"
            marginRight="auto"
            maxWidth={maxWidth}
        >
            {children}
        </Box>
    );
};

export default CenteredContent;
